import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  organisationKeyID: "",
  returnUrl: "",
  paymentGatewayID: "",
  isContractEnabled: "",
  tnCTemplateKeyID: "",
  contractTemplates: [],
  contractEmailTemplateKeyID: "",
  quoteTypeID: [],
  quoteTemplates: [],
  quoteEmailTemplateKeyID: "",
  fontFamilyID: "",
  fontSizeHeading: "",
  fontSizeText: "",
  buttonColor: "",
  backgroundServiceCategoryColor: "",
  proposalForLabel: "",
  proposalTypeLabel: "",
  customSingleLabel: "",
  packagedStandardLabel: "",
  packagedCustomisableLabel: "",
  signContractLabel: "",
  getQuoteLabel: "",
  successUrl: "",
  cancelledUrl: "",
  cancelButtonColor: "#",
  bodyBackGroundColor: "",
  formBackGroundColor: "",
  openSuccessUrlInNewTab: "",
  openCancelUrlInNewTab: "",
  fontColor: "",
  remainingESignatures: "",
};

const storageSlice = createSlice({
  name: "Storage",
  initialState,
  reducers: {
    updateState: (state, action) => {
      assignValueInState(action.payload, state);
    },
    resetState: (state) => {
      assignValueInState(initialState, state);
    },
  },
});

const assignValueInState = (obj, state) => {
  for (const key in obj) {
    state[key] = obj[key];
  }
};

export const { updateState, resetState } = storageSlice.actions;
export default storageSlice.reducer;
